import { render, staticRenderFns } from "./ContinuousFilingTask.vue?vue&type=template&id=5edb1854&scoped=true&"
import script from "./ContinuousFilingTask.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingTask.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingTask.vue?vue&type=style&index=0&id=5edb1854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb1854",
  null
  
)

export default component.exports